var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer-container",style:(_vm.maxWidthStyle)},[_c('footer-indicator',{attrs:{"version":_vm.appVersion}}),_c('div',{staticClass:"spacer"}),_c('footer-navigation',{attrs:{"options":_vm.navigationOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }